document.addEventListener('DOMContentLoaded', async () => {
  document.querySelectorAll('[data-shopify-buy-trigger="true"]').forEach(container => {
    // ボタン要素(最初の<button>)を取得
    const button = container.querySelector('button');
    if (!button) return; // buttonがなければスキップ
    const { productVariantId, storefrontEndpoint, storefrontToken } = container.dataset;
    // Product設定が無ければ無視
    if (!productVariantId || !storefrontEndpoint || !storefrontToken) return;
    const merchandiseId = `gid://shopify/ProductVariant/${productVariantId}`;
    const endpointUrl = `https://${storefrontEndpoint}.myshopify.com/api/2025-04/graphql.json`;
    // 二重バインド防止
    if (container.dataset.buyBound === '1') return;
    container.dataset.buyBound = '1';
    button.addEventListener('click', async (e) => {
      e.preventDefault();
      if (button.disabled) return;
      button.disabled = true;
      try {
        // カート生成＋商品追加＋checkoutUrl取得
        const res = await fetch(endpointUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': storefrontToken,
          },
          body: JSON.stringify({
            query: `
              mutation CreateCart($lines: [CartLineInput!]){
                cartCreate(input: { lines: $lines }) {
                  cart { id checkoutUrl }
                  userErrors { field message }
                }
              }
            `,
            variables: {
              lines: [{ merchandiseId, quantity: 1 }],
            },
          }),
        });
        if (!res.ok) throw new Error(res.status);
        const json = await res.json();
        if (json.errors?.length) { throw new Error(json.errors.map(e => e.message).join('; ')); }
        const payload = json.data?.cartCreate;
        if (!payload) throw new Error('Invalid response: cartCreate missing');
        if (payload.userErrors?.length) { throw new Error(payload.userErrors.map(e => e.message).join('; ')); }
        const checkoutUrl = payload.cart?.checkoutUrl;
        if (!checkoutUrl) throw new Error('checkoutUrl not returned');
        window.location.href = checkoutUrl;
      } catch (error) {
        console.error(error);
        alert('購入処理に失敗しました。時間をおいて再度お試しください。');
      } finally {
        button.disabled = false;
      }
    });
  });
});